import IReminder from "../models/reminder/IReminder";
import { apiSlice } from "./apiSlice";

const ROUTE = "/reminder";

const reminderApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getManyReminders: builder.query<IReminder[], string>({
            query: (auctionId) => `${ROUTE}/?auctionId=${auctionId}`
        })
    })
});

export const { useGetManyRemindersQuery } = reminderApiSlice;
